import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { HomeBrowserSupportModalComponent } from './home-browser-support-modal.component';

@Injectable({
  providedIn: 'root',
})
export class HomeBrowserSupportModalService {
  homeBrowserSupportDialogRef: MatDialogRef<HomeBrowserSupportModalComponent>;

  constructor(private dialog: MatDialog) {}

  openHomeBrowserSupportDialog(): Observable<any> {
    this.homeBrowserSupportDialogRef = this.dialog.open(HomeBrowserSupportModalComponent, {
      width: '500px',
      panelClass: 'home-browser-support-modal',
    });

    return this.homeBrowserSupportDialogRef.afterClosed();
  }
}
